/* eslint-disable import/no-unresolved */
/**
 * External Dependencies
 */

// It's a peer dependency loaded from the window
// eslint-disable-next-line import/no-unresolved
import 'jquery'
import Swiper, {
  EffectFade, Autoplay, Navigation, Pagination,
} from 'swiper'

import 'swiper/css/bundle'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import tippy from 'tippy.js'

Swiper.use([EffectFade, Autoplay, Navigation, Pagination])

$(() => {
  // Time the slides
  const $introVid = $('#vid-intro')

  if ($introVid.length) {
    const textSlider = new Swiper('.swiper_textSlides', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      allowTouchMove: false,
    })
    $introVid[0].addEventListener('timeupdate', () => {
      const vidCurrentTime = $introVid[0].currentTime

      if (vidCurrentTime >= 6.8 && vidCurrentTime < 13.8) {
        textSlider?.slideTo(1)
      } else if (vidCurrentTime >= 13.8 && vidCurrentTime <= 20.8) {
        textSlider?.slideTo(2)
      } else if (vidCurrentTime >= 20.8 && vidCurrentTime <= 28) {
        textSlider?.slideTo(3)
      } else {
        textSlider?.slideTo(0)
      }
    })
  }

  // eslint-disable-next-line no-unused-vars
  const chyronSlider = new Swiper('.swiper_chyronSlides', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: () => {
        $('.swiper_chyronSlides').css('height', '100%')
        $('.swiper_chyronSlides .swiper-slide').css('height', '100%')
        $('.swiper_chyronSlides .swiper-slide a').css({
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100%',
        })
      },
    },
  })

  // eslint-disable-next-line no-unused-vars
  const joinCarousel = new Swiper('.swiper_joinCarousel', {
    effect: 'fade',
    loop: true,
    autoHeight: true,
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination_CarouselJoin',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-join-button-next',
      prevEl: '.swiper-join-button-prev',
    },
  })
})

const resetVertical = () => (window.innerWidth < 769 ? 'stretch' : 'center')

$('.navbar-toggle').on('click', () => {
  $('#offcanvas-navigation').addClass('offcanvas-navigation__active')
  $('#primary-navigation-toggle').addClass('navtoggle-open__hide')
  $('#navtoggle-close').addClass('navtoggle-close__show')
})

$('#navtoggle-close').on('click', () => {
  $('#offcanvas-navigation').removeClass('offcanvas-navigation__active')
  $('#navtoggle-close').removeClass('navtoggle-close__show')
  $('#primary-navigation-toggle').removeClass('navtoggle-open__hide')
})

$('.sub-menu-toggle').on('click', () => {
  const isActive = $('.sub-menu').hasClass('sub-menu_show')

  if (isActive) {
    $('.sub-menu').removeClass('sub-menu_show')
  } else {
    $('.sub-menu').addClass('sub-menu_show')
  }
})

const getPlacement = () => (window.innerWidth < 1024 ? 'bottom' : 'right')

tippy('[data-tippy-content]', {
  theme: 'light-border',
  placement: getPlacement(),
  touch: false,
})

// Make placement value dynamic
// See https://github.com/atomiks/tippyjs/issues/171
// Reposition homepage chyron
window.addEventListener('resize', () => {
  const el = $('.productCandidates_circleTippy')
  const chyronText = $('.swiper_chyronSlides .swiper-slide a')

  el.each((i) => {
    // eslint-disable-next-line no-underscore-dangle
    el[i]._tippy.props.placement = getPlacement()
  })
  chyronText.css('justify-content', resetVertical())
})

$('.productCandidates_circle')
  .on('mouseover', (e) => {
    $(e.currentTarget).addClass('active').siblings().addClass('inactive')
  })
  .on('mouseout', (e) => {
    $(e.currentTarget).removeClass('active').siblings().removeClass('inactive')
  })

$('.tabButton').on('click', (e) => {
  $('.tabButton.active').removeClass('active')
  $(e.currentTarget).addClass('active')
  $('.tabContent.active').removeClass('active')
  const tabNumber = $(e.currentTarget).attr('data-tab')
  const tabToOpen = `.tabContent[data-tab='${tabNumber}']`
  $(tabToOpen).addClass('active')
})

$('.durabilityTabs .tabContent').on('mouseenter', '.emsHoverTarget', (e) => {
  $(e.currentTarget).parents('.tabContent').addClass('emsHoverActive')
}).on('mouseleave', '.emsHoverTarget', (e) => {
  $(e.currentTarget).parents('.tabContent').removeClass('emsHoverActive')
})

/*  Link Our Company staff images to CPT
*  Wrapping image in anchor tags adds <br>'s before and after it
*  See https://github.com/wpcomvip/kodiak-sciences-inc/pull/170
* */
$('.staffGrid_MemberPicture__hasLink').on('click', (e) => {
  $(e.currentTarget).parent().find('.staffGrid_MemberText a')[0].click()
})

$('.siteFooter_BackToTop').on('click', (e) => {
  e.preventDefault()
  $('html, body').animate({ scrollTop: 0 }, 100)
})

// eslint-disable-next-line func-names
$('.barChart_productRowConditionWrap button').on('click', function () {
  const collapseButton = $(this).closest('.barChart_productRowConditionWrap').find('.barChart_productRowAccordionClose')

  collapseButton.toggleClass('hide')
  $(this).closest('.barChart_productRowConditionWrap').find('.barChart_productRowAccordionWrap.closed').slideToggle()
    .end()
    .find('svg')
    .toggleClass('expanded')
})

$('.js-productRowConditionToggleButton')
  .on({
    // eslint-disable-next-line object-shorthand
    mouseenter: function () { $(this).closest('.barChart_productRowConditionWrap').attr('style', 'background-color: #f3fdff') },
    // eslint-disable-next-line object-shorthand
    mouseleave: function () { $(this).closest('.barChart_productRowConditionWrap').attr('style', 'background-color: none') },
    // eslint-disable-next-line object-shorthand
    focus: function () { $(this).closest('.barChart_productRowConditionWrap').attr('style', 'background-color: #f3fdff') },
    // eslint-disable-next-line object-shorthand
    blur: function () { $(this).closest('.barChart_productRowConditionWrap').attr('style', 'background-color: none') },
  })

$('.js-productRowConditionCollapseButton')
  .on({
    // eslint-disable-next-line object-shorthand
    mouseenter: function () { $(this).parent().attr('style', 'background-color: #f3fdff') },
    // eslint-disable-next-line object-shorthand
    mouseleave: function () { $(this).parent().attr('style', 'background-color: none') },
    // eslint-disable-next-line object-shorthand
    focus: function () { $(this).parent().attr('style', 'background-color: #f3fdff') },
    // eslint-disable-next-line object-shorthand
    blur: function () { $(this).parent().attr('style', 'background-color: none') },
  })

// Timeline Animation
const $timelineWrap = $('.timelineWrap')
if ($timelineWrap.length > 0) {
  const timelineHeight = $timelineWrap.find('.timelinePathSvg').height()
  let timelineOffset = $timelineWrap.offset().top
  let timelineScrolling = false

  $(window).on('resize', () => {
    timelineOffset = $timelineWrap.offset().top
  })

  setTimeout(() => {
    timelineOffset = $timelineWrap.offset().top
  }, 1000)

  const timelineScrollCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        timelineScrolling = true
      } else {
        timelineScrolling = false
      }
    })
  }
  const options = {}

  const timelineScrollObserver = new IntersectionObserver(timelineScrollCallback, options)
  timelineScrollObserver.observe($timelineWrap[0])

  // set height of the svg path as constant
  const timelinePath = document.getElementById('timelinePath')
  const length = timelinePath.getTotalLength()

  // start positioning of svg drawing
  timelinePath.style.strokeDasharray = length

  // hide svg before scrolling starts
  timelinePath.style.strokeDashoffset = length

  window.addEventListener('scroll', () => {
    // eslint-disable-next-line max-len
    if (timelineScrolling) {
      const timelineYPos = ($(document).scrollTop() - timelineOffset) + (window.innerHeight / 2)
      // eslint-disable-next-line max-len
      const timelineScrollPercent = (timelineYPos / timelineHeight) * 0.8
      const anticipation = 0.01
      console.log('anticipation', anticipation)
      const draw = (length * (timelineScrollPercent - anticipation)) // subtract excess at end
      timelinePath.style.strokeDashoffset = length - draw
      const $milestones = $('.milestoneInfo')
      $('.timelineBall').each((i, el) => {
        if (timelineScrollPercent >= $(el).data('timeline-scroll-pct')) {
          $(el).addClass('active')
          $($milestones[i]).addClass('active')
        } else {
          $(el).removeClass('active')
          $($milestones[i]).removeClass('active')
        }
      })
    }
  })
}
